import { ProgressCircleComponent } from "@/components/progress/progress-circle";
import { Tooltip } from "@/components/ui/tooltip";
import { PermissionCode } from "@/constants/permissions";
import { useRoles } from "@/hooks/useRoles";
import { MobileUser } from "@/pages/users/schema/users.schema";
import { AppColors } from "@/styles/colors";
import {
  Box,
  Checkbox,
  CheckboxCheckedChangeDetails,
  Field,
  Text,
} from "@chakra-ui/react";

interface Props {
  item: MobileUser;
  handleCheck: (
    checked: CheckboxCheckedChangeDetails,
    item: MobileUser,
  ) => void;
  selectedToValidate?: MobileUser;
  loadingValidateUser: boolean;
}

export const UserMobileActions = ({
  handleCheck,
  selectedToValidate,
  item,
  loadingValidateUser,
}: Props) => {

  const { userPermissions } = useRoles();

  const hasWriteAccess = Boolean(
    userPermissions?.some(
      (p) =>
        p.codigo === PermissionCode.USERS &&
        p.tipoPermiso === "W",
    ),
  );

  const disabled =
    !hasWriteAccess ||
    (selectedToValidate?.id !== item.id && loadingValidateUser) ||
    item?.validaIdentidad;

  if (item?.baja) return null;

  return (
    <Box>
      {selectedToValidate?.id === item.id && loadingValidateUser ? (
        <ProgressCircleComponent size="xs" />
      ) : (
        <Tooltip
          openDelay={500}
          closeDelay={100}
          positioning={{ placement: "left" }}
          content={
            <Text fontSize="14px">
              {item?.validaIdentidad ? "Usuario validado" : "Validar usuario"}
            </Text>
          }
          contentProps={{
            css: {
              paddingX: "10px",
              "--tooltip-bg": AppColors.GREEN_PRIMARY,
            },
          }}
        >
          <Field.Root disabled={disabled}>
            <Checkbox.Root
              data-testid="checkbox-users"
              cursor={disabled ? "default" : "pointer"}
              checked={item?.validaIdentidad}
              onCheckedChange={(checked) => handleCheck(checked, item)}
            >
              <Checkbox.HiddenInput />
              <Checkbox.Control borderColor={AppColors.GRAY_BORDER_1} />
            </Checkbox.Root>
          </Field.Root>
        </Tooltip>
      )}
    </Box>
  );
};
